module.exports = __webpack_public_path__ + "static/the-rosie-project-f22233fd1feea6d33fd7d86dfed68854.jpg";